
import { defineComponent, PropType } from 'vue'
import { AppButton } from '@shared/ui'
import { useTipsModel } from '@entities/tips'

interface IData {
  paymentMethodLocal: string
}
export default defineComponent({
  name: 'PaymentMethod',
  components: { AppButton },
  props: {
    paymentMethod: {
      type: String as PropType<string>,
      required: true,
      default: 'sbp'
    },
    disabled: {
      type: Boolean as PropType<boolean>,
      required: false,
      default: false
    }
  },
  emits: ['closeModal', 'setPaymentMethod'],

  setup () {
    const tipsModel = useTipsModel()
    return { tipsModel }
  },

  data (): IData {
    return {
      paymentMethodLocal: 'sbp'
    }
  },
  mounted () {
    this.paymentMethodLocal = this.paymentMethod
  },
  methods: {
    choicePaymentMethod (val: string): void {
      if (this.disabled) {
        return
      }
      this.paymentMethodLocal = val
    },
    save (): void {
      this.$cookies.set('paymentMethod', this.paymentMethodLocal, {
        maxAge: 60 * 60 * 24 * 1
      })
      this.$emit('setPaymentMethod', this.paymentMethodLocal)
      this.$emit('closeModal')
    },
    toggleBanksModal (): void {
      this.$emit('closeModal')
    }
  }
})
